const indexData = [
  {
    label: '蜜桃精选',
    tag: 'HOT',
    icon: 'ri-heart-pulse-line',
    desc: '精选全网最热蜜桃动漫在线资源，每日更新推荐，羞羞动漫在线观看首选入口。',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
  },
  {
    label: '校园恋爱',
    tag: '热门',
    icon: 'ri-school-line',
    desc: '纯爱校园蜜桃动漫在线合集，羞羞动漫在线观看完整版全收录，青春悸动一网打尽。',
    color: 'text-accent-600',
    bg: 'bg-accent-50',
  },
  {
    label: '奇幻冒险',
    tag: '新番',
    icon: 'ri-magic-line',
    desc: '异世界奇幻蜜桃动漫在线系列，羞羞动漫在线高清播放全季完整版每日跟新。',
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
  {
    label: '新番速递',
    tag: 'NEW',
    icon: 'ri-rocket-line',
    desc: '最新羞羞动漫在线新番第一时间上线，48小时同步日区更新，追番不等待。',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
  },
  {
    label: '经典回顾',
    tag: '经典',
    icon: 'ri-vip-crown-line',
    desc: '高分经典蜜桃动漫在线重温，羞羞动漫在线观看完整版系列一集不落全收录。',
    color: 'text-accent-600',
    bg: 'bg-accent-50',
  },
  {
    label: '独家专题',
    tag: '独家',
    icon: 'ri-star-smile-line',
    desc: '站内独家整理蜜桃动漫在线专题策划，按主题分类羞羞动漫在线观看更便捷。',
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
  {
    label: '全部分类',
    tag: 'ALL',
    icon: 'ri-apps-line',
    desc: '按类型、年份、热度浏览全部蜜桃动漫在线资源，羞羞动漫在线免费观看总入口。',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            七大专题入口，快速找到你想看的蜜桃动漫在线资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {indexData.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="group p-6 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.bg} ${item.color}`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <span className="px-2 py-0.5 bg-primary-100/70 text-primary-600 text-xs font-semibold rounded-full">
                  {item.tag}
                </span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">
                {item.label}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
          {indexData.slice(3).map((item, i) => (
            <div
              key={i + 3}
              className="group p-6 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.bg} ${item.color}`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <span className="px-2 py-0.5 bg-primary-100/70 text-primary-600 text-xs font-semibold rounded-full">
                  {item.tag}
                </span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">
                {item.label}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}